const BACKOFFICE_TERMINALS = `terminals`;
const isHml = window?.location?.href?.includes("hml");

const BACKOFFICE_BASE = isHml ? `/hml-bo/` : `/bo/`;
const BACKOFFICE_COMPANIES = `companies`;

export const ROUTES_BACKOFFICE = {
  path: BACKOFFICE_BASE,
  fullPath: BACKOFFICE_BASE,
  DEV: {
    path: "dev",
    fullPath: `${BACKOFFICE_BASE}dev`,
  },
  COMPANIES: {
    path: BACKOFFICE_COMPANIES,
    fullPath: `${BACKOFFICE_BASE}${BACKOFFICE_COMPANIES}`,

    SHOW: {
      path: `${BACKOFFICE_COMPANIES}/:id`,
      fullPath: (id: number) =>
        `${BACKOFFICE_BASE}${BACKOFFICE_COMPANIES}/${id}`,
    },
  },
  TERMINALS: {
    path: BACKOFFICE_TERMINALS,
    fullPath: `${BACKOFFICE_BASE}${BACKOFFICE_TERMINALS}`,
  }
};

const LEGACY_BACKOFFICE_BASE = `https://webapp.barte.com`;
const LEGACY_BACKOFFICE_APP_BASE = `${LEGACY_BACKOFFICE_BASE}/backoffice/`;

export const ROUTES_LEGACY_BACKOFFICE = {
  path: LEGACY_BACKOFFICE_APP_BASE,
  fullPath: LEGACY_BACKOFFICE_APP_BASE,
  COMPANIES: {
    path: "companies",
    fullPath: `${LEGACY_BACKOFFICE_APP_BASE}companies`,

    SHOW: {
      path: "companies/:id",
      fullPath: (id: number) => `${LEGACY_BACKOFFICE_APP_BASE}companies/${id}`,
    },
  },
  CHARGEBACKS: {
    path: "chargebacks",
    fullPath: `${LEGACY_BACKOFFICE_APP_BASE}chargebacks`,
  },
  TERMINALS: {
    path: "terminals",
    fullPath: `${LEGACY_BACKOFFICE_APP_BASE}terminals`,
  },
  LOGOUT: {
    fullPath: `${LEGACY_BACKOFFICE_BASE}/logout`,
  },
};
